import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/shared/lib/cn";

export type DashboardQuickAccessConfig = {
  icon: LucideIcon;
  cardClassName: string;
  iconClassName: string;
  labelClassName: string;
  activeClassName?: string;
};

export type DashboardQuickAccessItem = {
  id: string;
  href: string;
  label: string;
};

type DashboardQuickAccessProps = {
  items: DashboardQuickAccessItem[];
  configById: Record<string, DashboardQuickAccessConfig>;
  activeId?: string;
  onSelect?: (id: string) => void;
  className?: string;
};

export function DashboardQuickAccess({
  items,
  configById,
  activeId,
  onSelect,
  className,
}: DashboardQuickAccessProps) {
  return (
    <div className={cn("grid grid-cols-2 gap-3 md:grid-cols-4", className)}>
      {items.map((item) => {
        const config = configById[item.id];
        if (!config) return null;

        const Icon = config.icon;
        const isActive = activeId === item.id;

        return (
          <Link
            key={item.id}
            to={item.href}
            onClick={() => onSelect?.(item.id)}
            className={cn(
              "theme-card flex min-h-[128px] cursor-pointer flex-col items-center justify-center gap-3.5 p-6 text-center transition-all hover:shadow-[var(--shadow-sm)]",
              config.cardClassName,
              isActive && config.activeClassName,
            )}
          >
            <div
              className={cn(
                "flex h-14 w-14 items-center justify-center rounded-2xl transition-transform hover:scale-105",
                config.iconClassName,
              )}
            >
              <Icon size={24} strokeWidth={2} />
            </div>
            <span className={cn("text-sm", config.labelClassName)}>{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
}
